/* tslint:disable: no-switch-case-fall-through */
import { ActionWithPayload } from '../../app.interfaces';

import { helpers } from '../../helpers';
import { ViewActions } from './view.actions';
import { ViewState } from './view.interfaces';

export const viewInitialState: ViewState = {
  modal: {
    active: false,
    loading: false,
    content: {}
  },
  modalImage: {
    active: false,
    loading: false,
    content: {}
  },
  alerts: [],
  fullscreen: false,
  loading: false,
  audioExtPlaying: false,
  audioExtPlayingAccepted: false
};

export function viewReducer(state = viewInitialState, {type, payload}: ActionWithPayload): ViewState {
  let nextState: ViewState;
  switch (type) {

    case ViewActions.INSERT_ALERT: {
      nextState = helpers.immutAssign({}, state, {
        alerts: []
      });
      nextState.alerts.unshift(payload);

      return nextState;
    }

    case ViewActions.REMOVE_ALERT: {
      let nextAlerts = [];

      for (let i = 0; i < state.alerts.length; i++) {
        if (state.alerts[i].id !== payload) {
          nextAlerts.push(state.alerts[i]);
        }
      }

      nextState = helpers.immutAssign({}, state, {
        '>alerts': nextAlerts
      });

      return nextState;
    }

    case ViewActions.RESET_ALERT: {
      let nextAlerts = [];

      nextState = helpers.immutAssign({}, state, {
        '>alerts': nextAlerts
      });

      return nextState;
    }

    case ViewActions.AUDIO_EXT_STARTED: {
      nextState = helpers.immutAssign({}, state, {
        '>audioExtPlaying': true,
        '>audioExtPlayingAccepted': false
      });

      return nextState;
    }

    case ViewActions.AUDIO_EXT_ENDED: {
      nextState = helpers.immutAssign({}, state, {
        '>audioExtPlaying': false
      });

      return nextState;
    }

    case ViewActions.AUDIO_EXT_RESET_PLAY_ACCEPTED: {
      nextState = helpers.immutAssign({}, state, {
        '>audioExtPlayingAccepted': false
      });

      return nextState;
    }

    case ViewActions.AUDIO_EXT_PLAY_ACCEPTED: {
      nextState = helpers.immutAssign({}, state, {
        '>audioExtPlayingAccepted': true
      });

      return nextState;
    }

    case ViewActions.OPEN_MODAL: {
      nextState = helpers.immutAssign({}, state, {
        '>modal': {
          active: true,
          content: payload
        }
      });
      return nextState;
    }

    case ViewActions.CLOSE_MODAL: {
      nextState = helpers.immutAssign({}, state, {
        '>modal': {
          active: false,
          content: {}
        }
      });
      return nextState;
    }

    case ViewActions.OPEN_MODAL_IMAGE: {
      nextState = helpers.immutAssign({}, state, {
        '>modalImage': {
          active: true,
          content: payload
        }
      });
      return nextState;
    }

    case ViewActions.CLOSE_MODAL_IMAGE: {
      nextState = helpers.immutAssign({}, state, {
        '>modalImage': {
          active: false,
          content: {}
        }
      });
      return nextState;
    }

    case ViewActions.SET_MODAL_LOADING: {
      nextState = helpers.immutAssign({}, state, {
        modal: {
          loading: payload
        }
      });
      return nextState;
    }

    case ViewActions.CHANGE_VIEW: {
      nextState = helpers.immutAssign({}, state, {
        name: payload,
        loading: false
      });
      return nextState;
    }

    case ViewActions.SET_LOADING: {
      nextState = helpers.immutAssign({}, state, {
        loading: payload
      });
      return nextState;
    }

    case ViewActions.SET_FULLSCREEN: {
      nextState = helpers.immutAssign({}, state, {
        fullscreen: payload
      });
      return nextState;
    }

    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/logics/view/view.reducer.ts